import styled from 'styled-components/macro';

import { Images } from 'assets/images';
import { deviceMax } from 'utils/styles/breakpoints';
import { FONTS, FONT_FAMILY } from 'utils/styles/fonts';
import { COLORS } from 'utils/styles/colors';
import { BaseContentContainer } from 'utils/baseElements';
import { Section } from '../core/elemetns';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const StyledFooterSection = styled(Section)`
  height: 790px;
  padding: 103px 0;
  background-image: url(${Images.footerBgImage});
  background-position: bottom;

  @media ${deviceMax.mobileL} {
    height: 1270px;
    padding: 28px 0;
  }
`;

export const ContentContainer = styled(BaseContentContainer)`
  max-width: 1320px;

  @media ${deviceMax.laptopM} {
    max-width: 980px;
  }

  @media ${deviceMax.tablet} {
    max-width: 678px;
  }

  .footer-blocks {
    width: 100%;
    ${FLEX_CONTAINER.FlexSpaceBetweenRow}

    @media ${deviceMax.tablet} {
      flex-wrap: wrap;
    }

    @media ${deviceMax.mobileL} {
      justify-content: center;
    }
  }
`;

export const FooterBlock = styled.div`
  @media ${deviceMax.tablet} {
    max-width: 200px;
    width: 100%;

    :last-child {
      margin-right: auto;
    }
  }

  @media ${deviceMax.mobileL} {
    :last-child {
      margin-right: unset;
    }
  }

  ul {
    ${FONT_FAMILY.FontBold}
    list-style-type: none;
    ${FONTS.font24}

    @media ${deviceMax.laptopM} {
      ${FONTS.font20}
    }

    @media ${deviceMax.mobileL} {
      ${FONTS.font24}
    }

    li {
      padding: 15px 0;

      :first-child {
        padding-top: 30px;
      }
    }
  }

  &[name='media-icons'] {
    p {
      ${FONTS.font24}
      ${FONT_FAMILY.FontBold}
    }

    .media-icons-block {
      margin-top: 27px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 13px;

        @media ${deviceMax.laptopM} {
          width: 32px;
          height: 32px;
        }

        :last-child {
          margin-right: 0px;
        }
      }
    }
  }
`;

export const SubscribeFormBlock = styled.div`
  height: 58px;
  max-width: 679px;
  margin-top: 63px;
  ${FLEX_CONTAINER.FlexSpaceBetweenRow}

  @media ${deviceMax.laptopM} {
    max-width: 455px;
    height: 48px;
  }

  @media ${deviceMax.mobileL} {
    height: max-content;
    flex-direction: column;
  }

  input {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    border: 2px solid #818181;
    border-right: 0;
    border-radius: 16px 0px 0px 16px;
    ${FONT_FAMILY.FontLight}
    ${FONTS.font24}
    color: ${COLORS.black};

    ::placeholder {
      padding-left: 40px;

      @media ${deviceMax.mobileL} {
        padding-left: 17px;
      }
    }

    @media ${deviceMax.laptopM} {
      ${FONTS.font16}
    }

    @media ${deviceMax.mobileL} {
      height: 50px;
      border-radius: 8px;
    }
  }

  button {
    width: 231px;
    height: 100%;
    background: ${COLORS.blue};
    border-radius: 0px 16px 16px 0px;
    ${FONT_FAMILY.FontBold}
    color: ${COLORS.white};
    ${FONTS.font24}

    @media ${deviceMax.laptopM} {
      ${FONTS.font16}
    }

    @media ${deviceMax.mobileL} {
      width: 100%;
      height: 50px;
      margin-top: 16px;
      border-radius: 8px;
    }
  }
`;
